import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bezier, vector, nodes"} maskId="square-filled-radius-0-stroke-1-IconBezier"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V9H5.5V15H3V21H8.75V18.5H15V21H21V15H18.5V9H21V3H15V5.5H9V3H3ZM9 6.5H15V9H17.5V15H15V17.5H8.75V15H6.5V9H9V6.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBezier;
